<script lang="ts" setup>
  import AltibbiLoginForm from '@/components/authDialog/AltibbiLoginForm.vue'

  definePage({
    meta: {
      layout: 'blank',
      unauthenticated: true,
    },
  })
</script>

<template>
  <v-container class="h-screen d-flex align-center justify-center bg-login-bg">
    <altibbi-login-form :modal-mode="false" />
  </v-container>
</template>
